/* sensix — theme.js
   mobile nav · product variants + gallery · cart · account forms */
(function () {
  'use strict';

  var settings = window.theme || {};
  var moneyFormat = settings.moneyFormat || '${{amount}}';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || moneyFormat;
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return units + (parts[1] ? decimal + parts[1] : '');
    }

    var match = fmt.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // close open nav dropdowns when clicking elsewhere
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.site-nav__details[open]').forEach(function (details) {
      if (!details.contains(e.target)) details.removeAttribute('open');
    });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10) || 0;
    var min = input.min === '' ? 0 : parseInt(input.min, 10);
    var next = (parseInt(input.value, 10) || 0) + delta;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart: submit updates on quantity change ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var cartTimer;
    cartForm.addEventListener('change', function (e) {
      if (e.target.name !== 'updates[]') return;
      clearTimeout(cartTimer);
      cartTimer = setTimeout(function () { cartForm.submit(); }, 400);
    });
  }

  /* ---------- collection sort ---------- */
  document.querySelectorAll('[data-sort-by]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- product section: variants + gallery ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (root) {
    initGallery(root);
    initVariants(root);
  });

  function initGallery(root) {
    var mainImage = root.querySelector('[data-main-image]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!mainImage || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImage.src = thumb.getAttribute('data-src');
        mainImage.srcset = thumb.getAttribute('data-srcset') || '';
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  function initVariants(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    var form = root.querySelector('[data-product-form]');
    if (!jsonEl || !form) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var saleBadge = root.querySelector('[data-sale-badge]');
    var skuWrap = root.querySelector('[data-sku-wrap]');
    var skuEl = root.querySelector('[data-sku]');
    var addButton = root.querySelector('[data-add-button]');
    var addButtonText = root.querySelector('[data-add-button-text]');
    var mainImage = root.querySelector('[data-main-image]');

    if (!selects.length) return;

    function currentVariant() {
      var selected = selects.map(function (s) { return s.value; });
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selected[index];
        });
      });
    }

    function update() {
      var variant = currentVariant();

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addButtonText) addButtonText.textContent = 'unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);

      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        compareEl.classList.toggle('hidden', !onSale);
      }
      if (saleBadge) saleBadge.classList.toggle('hidden', !onSale);

      if (skuEl) skuEl.textContent = variant.sku || '';
      if (skuWrap) skuWrap.classList.toggle('hidden', !variant.sku);

      if (addButton) addButton.disabled = !variant.available;
      if (addButtonText) addButtonText.textContent = variant.available ? 'add to cart' : 'sold out';

      if (variant.featured_image && mainImage) {
        var src = variant.featured_image.src;
        mainImage.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1100';
        mainImage.removeAttribute('srcset');
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    selects.forEach(function (select) { select.addEventListener('change', update); });
  }

  /* ---------- generic show/hide toggles (address forms) ---------- */
  document.querySelectorAll('[data-toggle-target]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-toggle-target'));
      if (!target) return;
      target.hidden = !target.hidden;
      btn.setAttribute('aria-expanded', target.hidden ? 'false' : 'true');
    });
  });

  /* ---------- address delete ---------- */
  document.querySelectorAll('[data-delete-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById(btn.getAttribute('data-delete-trigger'));
      if (!form) return;
      var message = form.getAttribute('data-confirm') || 'Delete this address?';
      if (window.confirm(message)) form.submit();
    });
  });

  /* ---------- address country / province selects ---------- */
  document.querySelectorAll('[data-country-select]').forEach(function (countrySelect) {
    var wrap = document.getElementById(countrySelect.getAttribute('data-province-target') || '');
    var provinceSelect = wrap ? wrap.querySelector('[data-province-select]') : null;

    function updateProvinces() {
      if (!wrap || !provinceSelect) return;
      var option = countrySelect.options[countrySelect.selectedIndex];
      var provinces = [];
      try { provinces = JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (err) {}
      provinceSelect.innerHTML = '';
      if (!provinces.length) {
        wrap.hidden = true;
        return;
      }
      provinces.forEach(function (province) {
        var opt = document.createElement('option');
        opt.value = province[0];
        opt.textContent = province[1];
        provinceSelect.appendChild(opt);
      });
      var defaultProvince = provinceSelect.getAttribute('data-default');
      if (defaultProvince) provinceSelect.value = defaultProvince;
      wrap.hidden = false;
    }

    var defaultCountry = countrySelect.getAttribute('data-default');
    if (defaultCountry) countrySelect.value = defaultCountry;
    countrySelect.addEventListener('change', updateProvinces);
    updateProvinces();
  });

  /* ---------- login / recover toggle ---------- */
  var loginView = document.querySelector('[data-login-view]');
  var recoverView = document.querySelector('[data-recover-view]');
  if (loginView && recoverView) {
    var showRecover = function (show) {
      recoverView.hidden = !show;
      loginView.hidden = show;
    };
    document.querySelectorAll('[data-show-recover]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        showRecover(true);
        window.location.hash = 'recover';
      });
    });
    document.querySelectorAll('[data-show-login]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        showRecover(false);
        if (window.history.replaceState) window.history.replaceState({}, '', window.location.pathname);
      });
    });
    if (window.location.hash === '#recover') showRecover(true);
  }
})();
